import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment from 'moment';
// import { getCache } from '@/utils/session';

Vue.config.productionTip = false;
import 'normalize.css/normalize.css'; //css resets
import '@/styles/index.scss'; // global css

import './icons'; //icon

import './permission'; // 路由导航守卫

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);
import config from '@/config/index';
Vue.use(config);
import scrollBar from '@/components/scrollBar';
import '@/components/scrollBar/index.scss';
Vue.component('scroll-bar', scrollBar);
import loading from '@/components/loading/loading'; // 引入loading
Vue.use(loading); // 全局使用loading

Vue.filter('dateFormat', function (dataStr, patten = 'YYYY-MM-DD HH:mm:ss') {
  if (!dataStr) return '--';
  return moment(dataStr).format(patten);
});

// 定义全局指令（已注释权限检查）
Vue.directive('permission', {
  inserted(el, binding, vnode) {
    // 注释掉权限检查，默认显示所有元素
    /*
    // 检查权限
    const permission = binding.value;
    const userInfo = getCache('USERINFO');
    if (userInfo.authority) {
      const authority = userInfo.authority.split(',');
      if (!authority.includes(String(permission))) {
        // 如果用户没有权限，移除DOM元素
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
    */
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');